import { render, staticRenderFns } from "./ProductosIndex.vue?vue&type=template&id=24c166d8"
import script from "./ProductosIndex.vue?vue&type=script&lang=js"
export * from "./ProductosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports